import { ReferralStats } from '@/lib/types/account';
import { createHttpClient, QueryParams } from '../httpClient';
import {
  mapDashboardDtoToReferralStats,
  mapReferralPaymentsPage,
  ReferralPaymentsResult,
} from './mappers';
import {
  InviteDto,
  ReferralPaymentsPageDto,
  ReferralPaymentsQueryParams,
  ReferralsDashboardDto,
} from './types';

export function createReferralsHttpWithToken() {
  const baseUrl = process.env.NEXT_PUBLIC_REFERRALS_URL;

  return createHttpClient({ baseUrl });
}

export async function fetchReferralsDashboard(): Promise<ReferralStats> {
  const client = createReferralsHttpWithToken();
  const dto = await client.get<ReferralsDashboardDto>('/referrals/dashboard');
  return mapDashboardDtoToReferralStats(dto);
}

export async function fetchInvite(): Promise<InviteDto> {
  const client = createReferralsHttpWithToken();
  return client.get<InviteDto>('/invite');
}

export async function fetchReferralPayments(
  params?: ReferralPaymentsQueryParams,
): Promise<ReferralPaymentsResult> {
  const client = createReferralsHttpWithToken();
  const dto = await client.get<ReferralPaymentsPageDto>('/payments', {
    query: params as QueryParams,
  });
  return mapReferralPaymentsPage(dto);
}
